import { css } from "@linaria/core";

import { colorProps } from "../../styles/variables";

export const barCls = css`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000031;

  height: 2px;
  width: 100%;

  background: rgb(var(${colorProps.primary}));

  pointer-events: none;
`;

export const pegCls = css`
  position: absolute;
  right: 0;

  height: 100%;
  width: 100px;

  box-shadow:
    0 0 10px rgb(var(${colorProps.primary})),
    0 0 5px rgb(var(${colorProps.primary}));

  display: block;

  pointer-events: none;

  opacity: 1;
  transform: rotate(3deg) translate(0, -4px);
`;
